import { baseService, GLOBAL_TAG_TYPES } from '@repo/services';

export interface ABFeaturesResponse {
  enabled_features: string[];
}

const abFeaturesService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getUserABFeatures: build.query<ABFeaturesResponse, void>({
      query: () => ({
        method: 'GET',
        url: '/v1/features/user_features',
      }),
      providesTags: [GLOBAL_TAG_TYPES.userFeatures],
      // Cache for 30 minutes to avoid excessive API calls
      keepUnusedDataFor: 1800,
    }),
  }),
});

export const {
  useGetUserABFeaturesQuery,
  useLazyGetUserABFeaturesQuery,
} = abFeaturesService;
